import { useState, useEffect } from "react";
import Button from "../base/Button";
import { Link, useLocation } from "react-router-dom";

import Project1Image from "../../assets/logo/logo-light.webp";
export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();



  // Check for saved dark mode preference or default to false
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    if (savedTheme === "dark" || (!savedTheme && prefersDark)) {
      setIsDarkMode(true);
      document.documentElement.classList.add("dark");
    }
  }, []);

  localStorage.setItem("theme", "light");



  return (
    <header className="bg-gray-900 shadow-sm border-b border-gray-700 sticky top-0 z-50 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={isDarkMode ? Project1Image : Project1Image}
              alt="Designs By DMI"
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/" ? "text-[#e18033]" : ""
                }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/services" ? "text-[#e18033]" : ""
                }`}
            >
              Services
            </Link>
            <Link
              to="/process"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/process" ? "text-[#e18033]" : ""
                }`}
            >
              Process
            </Link>
            <Link
              to="/portfolio"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/portfolio" ? "text-[#e18033]" : ""
                }`}
            >
              Portfolio
            </Link>
            <Link
              to="/about"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/about" ? "text-[#e18033]" : ""
                }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/contact" ? "text-[#e18033]" : ""
                }`}
            >
              Contact
            </Link>
          </div>

          {/* Dark Mode Toggle & CTA Button */}
          <div className="hidden md:flex items-center space-x-4">

            <a
              href="https://partner.designsbydmi.com/"
              target="__Blank__"
            >
              <Button variant="outline" className="w-full">
                Sign In
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-[#e18033] dark:hover:text-[#e18033] cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-menu-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className={`block px-3 py-2 text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/" ? "text-[#e18033]" : ""
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/services"
                className={`block px-3 py-2 text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/services" ? "text-[#e18033]" : ""
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/portfolio"
                className={`block px-3 py-2 text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/portfolio" ? "text-[#e18033]" : ""
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Portfolio
              </Link>
              <Link
                to="/about"
                className={`block px-3 py-2 text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/about" ? "text-[#e18033]" : ""
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className={`block px-3 py-2 text-white hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors font-medium cursor-pointer ${location.pathname === "/contact" ? "text-[#e18033]" : ""
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
            <div className="pt-4 pb-3 flex gap-2">

              <a
                href="https://partner.designsbydmi.com/"
                target="__Blank__"
              >
                <Button variant="outline" className="w-full">
                  Sign In
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>

    </header>
  );
}
